<label class="resetIcon" (click)="refreshClicked()">
    <img src="../../../assets/images/refresh.svg" alt="refresh logo" />
</label>
